/* Quick add size picker: hover (or tap) the "+" on a product card to show the sizes; click a size to add that variant straight to the cart. */
/* With a mouse the sizes close automatically once the pointer leaves the "+" and the size grid. */
(function () {
  var CLOSE_DELAY = 150;
  var closeTimers = new WeakMap();
  var lastPointerType = 'mouse';

  function getSectionsToBundle() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function setButtonState(button, state) {
    button.classList.remove('is-added', 'is-error', 'btn--loading');
    if (state) button.classList.add(state);
  }

  function cancelClose(card) {
    var timer = closeTimers.get(card);
    if (timer) {
      clearTimeout(timer);
      closeTimers.delete(card);
    }
  }

  function setOpen(card, open) {
    if (!card) return;
    cancelClose(card);
    card.classList.toggle('is-size-open', open);
    var toggle = card.querySelector('.quick-add-size__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function scheduleClose(card) {
    cancelClose(card);
    closeTimers.set(
      card,
      setTimeout(function () {
        setOpen(card, false);
      }, CLOSE_DELAY)
    );
  }

  function closeAll(except) {
    document.querySelectorAll('.product-card.is-size-open').forEach(function (card) {
      if (card !== except) setOpen(card, false);
    });
  }

  function isMouse(event) {
    return event.pointerType ? event.pointerType === 'mouse' : lastPointerType === 'mouse';
  }

  function addVariantToCart(button) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.classList.contains('is-disabled') || button.classList.contains('btn--loading')) {
      return;
    }
    if (!window.FoxTheme || !window.FoxTheme.routes) {
      console.error('Quick add size: FoxTheme routes are not available.');
      return;
    }

    var group = button.closest('.quick-add-size');
    var buttons = group ? group.querySelectorAll('.quick-add-size__option') : [button];
    buttons.forEach(function (btn) {
      btn.setAttribute('aria-disabled', 'true');
    });
    setButtonState(button, 'btn--loading');

    var sections = getSectionsToBundle();
    var body = JSON.stringify({ id: variantId, quantity: 1, sections: sections });

    fetch(window.FoxTheme.routes.cart_add_url, Object.assign({}, window.FoxTheme.utils.fetchConfig(), { body: body }))
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            var message = (data && (data.description || data.message)) || 'Unable to add to cart';
            throw new Error(message);
          }
          return data;
        });
      })
      .then(function (addResult) {
        return fetch(window.FoxTheme.routes.cart_url, Object.assign({}, window.FoxTheme.utils.fetchConfig()))
          .then(function (response) {
            return response.json();
          })
          .then(function (cartJson) {
            cartJson.sections = addResult.sections;
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          });
      })
      .then(function () {
        setButtonState(button, 'is-added');
        setTimeout(function () {
          setButtonState(button, null);
          setOpen(button.closest('.product-card'), false);
        }, 1200);
      })
      .catch(function (error) {
        console.error('Quick add size error:', error);
        setButtonState(button, 'is-error');
        setTimeout(function () {
          setButtonState(button, null);
        }, 1500);
      })
      .finally(function () {
        buttons.forEach(function (btn) {
          btn.removeAttribute('aria-disabled');
        });
      });
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      lastPointerType = event.pointerType || 'mouse';
    },
    true
  );

  /* Mouse: hovering the "+" opens the sizes; leaving the "+" and the grid closes them. */
  document.addEventListener('pointerover', function (event) {
    if (!isMouse(event)) return;
    var zone = event.target.closest && event.target.closest('.quick-add-size__toggle, .quick-add-size');
    if (!zone) return;
    var card = zone.closest('.product-card');
    if (!card) return;
    if (zone.classList.contains('quick-add-size__toggle')) {
      closeAll(card);
      setOpen(card, true);
    } else {
      cancelClose(card);
    }
  });

  document.addEventListener('pointerout', function (event) {
    if (!isMouse(event)) return;
    var zone = event.target.closest && event.target.closest('.quick-add-size__toggle, .quick-add-size');
    if (!zone) return;
    var card = zone.closest('.product-card');
    if (!card || !card.classList.contains('is-size-open')) return;
    var next = event.relatedTarget;
    if (next && next.closest && next.closest('.quick-add-size__toggle, .quick-add-size') && next.closest('.product-card') === card) {
      return;
    }
    scheduleClose(card);
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.quick-add-size__toggle');
    if (toggle) {
      event.preventDefault();
      var card = toggle.closest('.product-card');
      if (lastPointerType === 'mouse') {
        /* hover already opened it; a click keeps it open */
        closeAll(card);
        setOpen(card, true);
      } else {
        var willOpen = !card.classList.contains('is-size-open');
        closeAll(card);
        setOpen(card, willOpen);
      }
      return;
    }

    var button = event.target.closest('.quick-add-size__option');
    if (button) {
      event.preventDefault();
      addVariantToCart(button);
      return;
    }

    if (!event.target.closest('.quick-add-size')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
